"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const EmailVerification_1 = require("@/common/components/EmailVerification");
const detect_utils_1 = require("@/common/detect_utils");
const string_utils_1 = require("@/common/string_utils");
const FormControlLabel_1 = __importDefault(require("@mui/material/FormControlLabel"));
const Checkbox_1 = __importDefault(require("@mui/material/Checkbox"));
const _1 = require(".");
function default_1({ signUpInputForm, }) {
    var _a, _b;
    const { watch, resetField, register, formState: { errors }, clearErrors, } = signUpInputForm;
    const { t } = (0, react_i18next_1.useTranslation)();
    const newPassword = watch('new_pwd') || '';
    const hasAlphabet = /[a-zA-Z]/.test(newPassword);
    const hasNumber = /\d/.test(newPassword);
    const hasSpecialChar = /[!@#$%^&*_\-.?]/.test(newPassword);
    const is8orMore = newPassword.length >= 8;
    const passwordConfirm = watch('pwd_confirm') || '';
    const isPasswordConfirmed = Boolean(passwordConfirm) && newPassword === passwordConfirm;
    const { capsLockErrorMsg, detectCapsLock } = (0, detect_utils_1.useDetectCapsLock)();
    const passwordErrMsg = capsLockErrorMsg || ((_a = errors.new_pwd) === null || _a === void 0 ? void 0 : _a.message) || ((_b = errors.pwd_confirm) === null || _b === void 0 ? void 0 : _b.message);
    const pwdErrMsjObj = (0, string_utils_1.passwordErrorMessages)();
    const validatePwdSpecialChars = (value) => {
        if (value) {
            const replacedTestString = value === null || value === void 0 ? void 0 : value.replace(/[a-zA-Z0-9]/g, '*');
            return /^[!@#$%^&*_\-.?]+$/.test(replacedTestString) || pwdErrMsjObj.notAllowedChars;
        }
        else
            return true;
    };
    const [isPasswordValid, setIsPasswordValid] = (0, react_1.useState)(false);
    const onPasswordInputChange = (e) => {
        if (detect_utils_1.passwordRegex.test(e.currentTarget.value)) {
            clearErrors('pwd_confirm');
            window.setTimeout(() => setIsPasswordValid(true), 300);
        }
        else {
            resetField('pwd_confirm');
            setIsPasswordValid(false);
        }
    };
    const [showPassword, setShowPassword] = (0, react_1.useState)(false);
    return ((0, jsx_runtime_1.jsxs)(_1.SignUpEmailVerificationWrapper, { children: [(0, jsx_runtime_1.jsx)("h4", { children: t('비밀번호') }), (0, jsx_runtime_1.jsx)(EmailVerification_1.EmailVerificationInputDiv, { children: (0, jsx_runtime_1.jsx)("input", Object.assign({ type: showPassword ? 'text' : 'password', autoComplete: "new-password", placeholder: t('비밀번호') }, register('new_pwd', {
                    required: pwdErrMsjObj.requiredPattern,
                    pattern: { value: /^\S+$/, message: pwdErrMsjObj.noEmptySpace },
                    validate: validatePwdSpecialChars,
                    maxLength: { value: 20, message: pwdErrMsjObj.exceededLength },
                    onChange: onPasswordInputChange,
                }), { onKeyUp: detectCapsLock })) }), isPasswordValid && ((0, jsx_runtime_1.jsx)(EmailVerification_1.EmailVerificationInputDiv, Object.assign({ css: { marginTop: '6px' } }, { children: (0, jsx_runtime_1.jsx)("input", Object.assign({ type: showPassword ? 'text' : 'password', autoComplete: "new-password", placeholder: t('비밀번호 확인') }, register('pwd_confirm', {
                    required: pwdErrMsjObj.diffConfirm,
                    validate: v => v === newPassword || pwdErrMsjObj.diffConfirm,
                }), { onKeyUp: detectCapsLock })) }))), !passwordErrMsg && !isPasswordValid && ((0, jsx_runtime_1.jsxs)("h5", Object.assign({ css: {
                    color: 'rgba(0, 0, 0, 0.4)',
                    span: { color: 'inherit', fontSize: 'inherit' },
                    '.pw_rule_matched': { color: '#6fcf97' },
                } }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: hasAlphabet ? 'pw_rule_matched' : undefined }, { children: t('영문') })), `, `, (0, jsx_runtime_1.jsx)("span", Object.assign({ className: hasNumber ? 'pw_rule_matched' : undefined }, { children: t('숫자') })), `, `, (0, jsx_runtime_1.jsx)("span", Object.assign({ className: hasSpecialChar ? 'pw_rule_matched' : undefined }, { children: t('특수문자') })), ` ${t('조합')} | `, (0, jsx_runtime_1.jsx)("span", Object.assign({ className: is8orMore ? 'pw_rule_matched' : undefined }, { children: t('8~20자') }))] }))), passwordErrMsg && (0, jsx_runtime_1.jsx)("h5", Object.assign({ css: { color: '#eb5757' } }, { children: passwordErrMsg })), isPasswordConfirmed && (0, jsx_runtime_1.jsx)("h5", Object.assign({ css: { color: '#6fcf97' } }, { children: t('비밀번호가 일치해요') })), (0, jsx_runtime_1.jsx)(FormControlLabel_1.default, { sx: {
                    m: '-7px',
                    mt: '23px',
                    '.MuiCheckbox-root': { p: '5.5px' },
                    '.MuiFormControlLabel-label': { fontSize: '12px', color: 'black' },
                }, control: (0, jsx_runtime_1.jsx)(Checkbox_1.default, { checked: showPassword, onChange: () => setShowPassword(!showPassword) }), label: t('비밀번호 보기') })] }));
}
exports.default = default_1;
